var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{ref:"editor",staticClass:"container-fluid",staticStyle:{"min-height":"35px"}},[_vm._v("\n        "+_vm._s(_vm.value_)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }